(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 66779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FormattedImage; }
/* harmony export */ });
/* harmony import */ var _FormattedImage_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12405);
/* harmony import */ var _FormattedImage_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_FormattedImage_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function FormattedImage(_ref) {
  var path = _ref.path,
      alt = _ref.alt,
      width = _ref.width,
      height = _ref.height,
      loading = _ref.loading;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
      srcSet: "".concat(path, "?w=").concat(width * 2, "&format=webp"),
      type: "image/webp"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
      srcSet: "".concat(path, "?w=").concat(width * 2),
      type: "image/jpeg"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
      width: width,
      height: height,
      srcSet: "".concat(path),
      className: (_FormattedImage_module_scss__WEBPACK_IMPORTED_MODULE_1___default().img),
      alt: alt,
      loading: loading
    })]
  });
}

/***/ }),

/***/ 28842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OfferBanner; }
/* harmony export */ });
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70131);
/* harmony import */ var _utils_analytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99700);
/* harmony import */ var _FormattedImage_FormattedImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66779);
/* harmony import */ var _OfferBannerSection_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98297);
/* harmony import */ var _OfferBannerSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_OfferBannerSection_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







function OfferBanner(_ref) {
  var _banner$icon;

  var banner = _ref.banner,
      sections = _ref.sections,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'links under home banner' : _ref$title;

  function onClickLink(section) {
    var _section$icon;

    var index = sections.indexOf(section);
    var name = section === null || section === void 0 ? void 0 : section.text;
    var image = section === null || section === void 0 ? void 0 : (_section$icon = section.icon) === null || _section$icon === void 0 ? void 0 : _section$icon.path;
    var promo = (0,_utils_analytics__WEBPACK_IMPORTED_MODULE_1__/* .objectToPromoEventTransformer */ .ED)(name, image, title, index);
    (0,_utils_analytics__WEBPACK_IMPORTED_MODULE_1__/* .selectPromotion */ .G5)(promo);
  }

  function onView(isVisible, section) {
    var _section$icon2;

    if (!isVisible) return;
    var index = sections.indexOf(section);
    var name = section === null || section === void 0 ? void 0 : section.text;
    var image = section === null || section === void 0 ? void 0 : (_section$icon2 = section.icon) === null || _section$icon2 === void 0 ? void 0 : _section$icon2.path;
    var promo = (0,_utils_analytics__WEBPACK_IMPORTED_MODULE_1__/* .objectToPromoEventTransformer */ .ED)(name, image, title, index);
    (0,_utils_analytics__WEBPACK_IMPORTED_MODULE_1__/* .viewPromotion */ .vk)(promo);
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_intersection_observer__WEBPACK_IMPORTED_MODULE_4__/* .InView */ .df, {
    as: "div",
    className: (_OfferBannerSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().bannerContainer),
    triggerOnce: true,
    onChange: function onChange(isVisible) {
      return onView(isVisible, banner);
    },
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
      className: (_OfferBannerSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().bannerTitle),
      children: banner.text
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
      href: banner.redirect_url || '#',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", {
        className: (_OfferBannerSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().imageContainer),
        onClick: function onClick() {
          return onClickLink(banner);
        },
        "aria-label": banner === null || banner === void 0 ? void 0 : banner.text,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_FormattedImage_FormattedImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          path: banner.icon.path,
          alt: banner.text || 'προσφορά',
          width: 320,
          height: 220,
          loading: "lazy"
        })
      })
    })]
  }, (_banner$icon = banner.icon) === null || _banner$icon === void 0 ? void 0 : _banner$icon.id);
}

/***/ }),

/***/ 95476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ OfferBannerSection; }
/* harmony export */ });
/* harmony import */ var _OfferBanner__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28842);
/* harmony import */ var _OfferBannerSection_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98297);
/* harmony import */ var _OfferBannerSection_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_OfferBannerSection_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




function OfferBannerSection(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$sections = _ref.sections,
      sections = _ref$sections === void 0 ? [] : _ref$sections,
      analyticsTitle = _ref.analyticsTitle;
  if (!sections.length) return null;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
    className: (_OfferBannerSection_module_scss__WEBPACK_IMPORTED_MODULE_2___default().section),
    children: [title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
      className: (_OfferBannerSection_module_scss__WEBPACK_IMPORTED_MODULE_2___default().sectionTitle),
      children: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      id: "listContainer",
      className: (_OfferBannerSection_module_scss__WEBPACK_IMPORTED_MODULE_2___default().listContainer),
      children: sections.map(function (s) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_OfferBanner__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
          banner: s,
          sections: sections,
          title: analyticsTitle || 'Our Products'
        }, s.redirect_url);
      }, [])
    })]
  });
}

/***/ }),

/***/ 51116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NextArrow; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5434);
/* harmony import */ var _NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80075);
/* harmony import */ var _NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





function NextArrow(_ref) {
  var _classNames;

  var onClick = _ref.onClick,
      carousel = _ref.carousel,
      smallArrow = _ref.smallArrow,
      leaflet = _ref.leaflet,
      category = _ref.category;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_classNames = {}, (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().categoryContainer), category), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container), !carousel), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().carouselContainer), carousel), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().leaflet), leaflet), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().smallArrow), smallArrow), _classNames)),
    onClick: onClick,
    "aria-label": "next",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_4__/* .MdOutlineKeyboardArrowRight */ .Bqb, {
      className: (_NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().icon),
      alt: "Arrow forward - Arrow right"
    })
  });
}

/***/ }),

/***/ 55416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PrevArrow; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5434);
/* harmony import */ var _PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19392);
/* harmony import */ var _PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





function PrevArrow(_ref) {
  var _classNames;

  var onClick = _ref.onClick,
      carousel = _ref.carousel,
      smallArrow = _ref.smallArrow,
      leaflet = _ref.leaflet,
      category = _ref.category;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_classNames = {}, (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().categoryContainer), category), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container), !carousel), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().carouselContainer), carousel), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().smallArrow), smallArrow), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().leaflet), leaflet), _classNames)),
    onClick: onClick,
    "aria-label": "previous",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_4__/* .MdOutlineKeyboardArrowLeft */ .RL9, {
      className: (_PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().icon),
      alt: "Arrow back - Arrow left"
    })
  });
}

/***/ }),

/***/ 31662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/pages/index.module.scss
var index_module = __webpack_require__(28833);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/CustomMetaHead.jsx
var CustomMetaHead = __webpack_require__(92536);
// EXTERNAL MODULE: ./src/components/DeliveryBanner/DeliveryBanner.jsx + 3 modules
var DeliveryBanner = __webpack_require__(54196);
// EXTERNAL MODULE: ./src/components/Footer/Footer.jsx + 5 modules
var Footer = __webpack_require__(31875);
// EXTERNAL MODULE: ./src/components/FooterUSPItem/FooterUSPItem.module.scss
var FooterUSPItem_module = __webpack_require__(96127);
var FooterUSPItem_module_default = /*#__PURE__*/__webpack_require__.n(FooterUSPItem_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/FooterUSPItem/FooterUSPItem.jsx




function FooterUSPItem(_ref) {
  var imgUrl = _ref.imgUrl,
      header = _ref.header,
      description = _ref.description;
  var replaced = description.replace(/<\/?p[^>]*>/g, '');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (FooterUSPItem_module_default()).container,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      className: (FooterUSPItem_module_default()).img,
      src: imgUrl,
      alt: "\u03C0\u03BF\u03BB\u03B9\u03C4\u03B9\u03BA\u03AD\u03C2 super market"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (FooterUSPItem_module_default()).text,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (FooterUSPItem_module_default()).header,
        children: header
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (FooterUSPItem_module_default()).description,
        children: replaced
      })]
    })]
  });
}

/* harmony default export */ var FooterUSPItem_FooterUSPItem = (FooterUSPItem);
// EXTERNAL MODULE: ./src/components/FooterUSP/FooterUSP.module.scss
var FooterUSP_module = __webpack_require__(86629);
var FooterUSP_module_default = /*#__PURE__*/__webpack_require__.n(FooterUSP_module);
;// CONCATENATED MODULE: ./src/components/FooterUSP/FooterUSP.jsx



function FooterUSP(_ref) {
  var _ref$footerUSP = _ref.footerUSP,
      footerUSP = _ref$footerUSP === void 0 ? [] : _ref$footerUSP;
  if (!footerUSP.length) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (FooterUSP_module_default()).section,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (FooterUSP_module_default()).container,
      children: footerUSP.map(function (usp) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(FooterUSPItem_FooterUSPItem, {
          imgUrl: usp.fields.sections[0].image.path,
          header: usp.fields.sections[0].heading,
          description: usp.fields.sections[0].text
        }, usp.uuid);
      })
    })
  });
}
// EXTERNAL MODULE: ./src/components/Header/Header.jsx + 8 modules
var Header = __webpack_require__(3266);
// EXTERNAL MODULE: ./node_modules/@ant-design/react-slick/es/index.js + 12 modules
var es = __webpack_require__(1515);
// EXTERNAL MODULE: ./src/components/swiper-buttons/NextArrow.jsx
var NextArrow = __webpack_require__(51116);
// EXTERNAL MODULE: ./src/components/swiper-buttons/PrevArrow.jsx
var PrevArrow = __webpack_require__(55416);
// EXTERNAL MODULE: ./src/components/Homepage/CarouselSection.module.scss
var CarouselSection_module = __webpack_require__(59517);
var CarouselSection_module_default = /*#__PURE__*/__webpack_require__.n(CarouselSection_module);
// EXTERNAL MODULE: ./node_modules/lodash/last.js
var last = __webpack_require__(10928);
var last_default = /*#__PURE__*/__webpack_require__.n(last);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(70131);
// EXTERNAL MODULE: ./src/utils/index.js
var utils = __webpack_require__(90952);
// EXTERNAL MODULE: ./src/utils/analytics.js
var analytics = __webpack_require__(99700);
// EXTERNAL MODULE: ./src/components/CarouselSectionSlideImage/CarouselSectionSlideImage.module.scss
var CarouselSectionSlideImage_module = __webpack_require__(29172);
var CarouselSectionSlideImage_module_default = /*#__PURE__*/__webpack_require__.n(CarouselSectionSlideImage_module);
;// CONCATENATED MODULE: ./src/components/CarouselSectionSlideImage/CarouselSectionSlideImage.jsx



function CarouselSectionSlideImage(_ref) {
  var path = _ref.path,
      alt = _ref.alt,
      index = _ref.index;
  var loading = index === 0 ? 'priority' : 'lazy';
  var fetchpriority = index === 0 ? 'high' : 'auto';
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      srcSet: "".concat(path, "?w=720&format=webp"),
      type: "image/webp",
      media: "(max-width: 360px)",
      width: "720",
      height: "192"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      srcSet: "".concat(path, "?w=720"),
      type: "image/jpeg",
      media: "(max-width: 360px)",
      width: "360",
      height: "96"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      srcSet: "".concat(path, "?w=750&format=webp"),
      type: "image/webp",
      media: "(max-width: 375px)",
      width: "750",
      height: "200"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      srcSet: "".concat(path, "?w=750"),
      type: "image/jpeg",
      media: "(max-width: 375px)",
      width: "375",
      height: "100"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      srcSet: "".concat(path, "?w=818&format=webp"),
      type: "image/webp",
      media: "(max-width: 414px)",
      width: "818",
      height: "222"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      srcSet: "".concat(path, "?w=818"),
      type: "image/jpeg",
      media: "(max-width: 414px)",
      width: "414",
      height: "111"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      srcSet: "".concat(path, "?w=1200&format=webp"),
      type: "image/webp",
      media: "(max-width: 600px)",
      width: "1200",
      height: "320"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      srcSet: "".concat(path, "?w=1200"),
      type: "image/jpeg",
      media: "(max-width: 600px)",
      width: "600",
      height: "160"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      srcSet: "".concat(path, "?w=1908&format=webp"),
      type: "image/webp",
      media: "(max-width: 1024)",
      width: "1908",
      height: "508"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      srcSet: "".concat(path, "?w=1908"),
      type: "image/jpeg",
      media: "(max-width: 1024px)",
      width: "1024",
      height: "273"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      srcSet: "".concat(path, "?w=2210&format=webp"),
      type: "image/webp",
      media: "(max-width: 1252px)",
      width: "2110",
      height: "562"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      srcSet: "".concat(path, "?w=2110"),
      type: "image/jpeg",
      media: "(max-width: 1252px)",
      width: "1252",
      height: "334"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      srcSet: "".concat(path, "?w=2548&format=webp"),
      type: "image/webp",
      media: "(max-width: 1366px)",
      width: "2548",
      height: "680"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      srcSet: "".concat(path, "?w=2548"),
      type: "image/jpeg",
      media: "(max-width: 1366px)",
      width: "1366",
      height: "365"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      srcSet: "".concat(path, "?w=2740&format=webp"),
      type: "image/webp",
      media: "(max-width: 1440px)",
      width: "2740",
      height: "730"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      srcSet: "".concat(path, "?w=2740"),
      type: "image/jpeg",
      media: "(max-width: 1440px)",
      width: "1440",
      height: "411"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      srcSet: "".concat(path, "?w=3042&format=webp"),
      type: "image/webp",
      media: "(max-width: 1540px)",
      width: "3042",
      height: "812"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      srcSet: "".concat(path, "?w=3042"),
      type: "image/jpeg",
      media: "(max-width: 1540px)",
      width: "1540",
      height: "411"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      srcSet: "".concat(path, "?w=3082&format=webp"),
      type: "image/webp",
      media: "(max-width: 1920px)",
      width: "3082",
      height: "822"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      srcSet: "".concat(path, "?w=3082"),
      type: "image/jpeg",
      media: "(max-width: 1920px)",
      width: "1920",
      height: "512"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      srcSet: "".concat(path),
      className: (CarouselSectionSlideImage_module_default()).img,
      alt: alt,
      loading: loading // eslint-disable-next-line react/no-unknown-property
      ,
      fetchpriority: fetchpriority
    })]
  });
}
// EXTERNAL MODULE: ./src/components/Homepage/CarouselSectionSlide.module.scss
var CarouselSectionSlide_module = __webpack_require__(64890);
var CarouselSectionSlide_module_default = /*#__PURE__*/__webpack_require__.n(CarouselSectionSlide_module);
;// CONCATENATED MODULE: ./src/components/Homepage/CarouselSectionSlide.jsx









var GA_SLIDE_CREATIVE_TAG = 'homepage_carousel';
function CarouselSection(_ref) {
  var index = _ref.index,
      slide = _ref.slide;
  var router = (0,next_router.useRouter)();

  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)({
    threshold: 0.25
  }),
      ref = _useInView.ref,
      inView = _useInView.inView;

  function onInView() {
    var _slide$icon;

    var name = slide === null || slide === void 0 ? void 0 : slide.text;
    var image = slide === null || slide === void 0 ? void 0 : (_slide$icon = slide.icon) === null || _slide$icon === void 0 ? void 0 : _slide$icon.path;
    var promo = (0,analytics/* objectToPromoEventTransformer */.ED)(name, image, GA_SLIDE_CREATIVE_TAG, index);
    (0,analytics/* viewPromotion */.vk)(promo);
  }

  function onClick() {
    var _slide$icon2;

    var name = slide === null || slide === void 0 ? void 0 : slide.text;
    var image = slide === null || slide === void 0 ? void 0 : (_slide$icon2 = slide.icon) === null || _slide$icon2 === void 0 ? void 0 : _slide$icon2.path;
    var promo = (0,analytics/* objectToPromoEventTransformer */.ED)(name, image, GA_SLIDE_CREATIVE_TAG, index);
    var redirectUrl = slide.redirect_url;
    (0,analytics/* selectPromotion */.G5)(promo);
    if (!redirectUrl) return;
    var url = new URL(redirectUrl);
    var urlFullPath = last_default()(url.toString().split(url.hostname));
    router.push(urlFullPath);
  }

  (0,react.useEffect)(function () {
    if (!inView) return utils/* earlyInUseEffect */.Z;
    onInView();
  }, [inView]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    ref: ref,
    className: (CarouselSectionSlide_module_default()).container,
    onClick: onClick,
    role: "link",
    tabIndex: "-1",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselSectionSlideImage, {
      path: slide.icon.path,
      alt: slide.text || 'προσφορά',
      index: index
    })
  }, slide.icon.id);
}
;// CONCATENATED MODULE: ./src/components/Homepage/CarouselSection.jsx






function CarouselSection_CarouselSection(_ref) {
  var _data$fields;

  var data = _ref.data;
  var slides = (data === null || data === void 0 ? void 0 : (_data$fields = data.fields) === null || _data$fields === void 0 ? void 0 : _data$fields.sections) || [];
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (CarouselSection_module_default()).color,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(es/* default */.Z, {
      autoplay: true,
      autoplaySpeed: 5000,
      className: (CarouselSection_module_default()).slider,
      infinite: true,
      nextArrow: /*#__PURE__*/(0,jsx_runtime.jsx)(NextArrow/* default */.Z, {
        carousel: true
      }),
      prevArrow: /*#__PURE__*/(0,jsx_runtime.jsx)(PrevArrow/* default */.Z, {
        carousel: true
      }),
      slidesToScroll: 1,
      slidesToShow: 1,
      speed: 500,
      children: slides.map(function (slide, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselSection, {
          index: index,
          slide: slide,
          key: slide.icon.id
        });
      })
    })
  });
}
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Homepage/SingleImageBanner.module.scss
var SingleImageBanner_module = __webpack_require__(54599);
var SingleImageBanner_module_default = /*#__PURE__*/__webpack_require__.n(SingleImageBanner_module);
;// CONCATENATED MODULE: ./src/components/Homepage/SingleImageBanner.jsx




function SingleImageBanner(_ref) {
  var _ref$data = _ref.data,
      text = _ref$data.text,
      fields = _ref$data.fields;
  var _fields$sections$ = fields.sections[0],
      path = _fields$sections$.icon.path,
      href = _fields$sections$.redirect_url;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (SingleImageBanner_module_default()).container,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: href || '#',
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: (SingleImageBanner_module_default()).img,
          src: path,
          alt: text
        })
      })
    })
  });
}

/* harmony default export */ var Homepage_SingleImageBanner = (SingleImageBanner);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/lib/index.js
var lib = __webpack_require__(51655);
// EXTERNAL MODULE: ./src/constants/routes.js
var routes = __webpack_require__(98924);
// EXTERNAL MODULE: ./src/store/products.js
var products = __webpack_require__(58345);
// EXTERNAL MODULE: ./src/components/Index/Categories.module.scss
var Categories_module = __webpack_require__(46318);
var Categories_module_default = /*#__PURE__*/__webpack_require__.n(Categories_module);
;// CONCATENATED MODULE: ./src/components/Index/Categories.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var CategoriesModal = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(260), __webpack_require__.e(3253), __webpack_require__.e(3919)]).then(__webpack_require__.bind(__webpack_require__, 33919));
}, {
  suspense: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(33919)];
    }
  }
});
var SLIDER_SETTINGS = {
  adaptiveHeight: true,
  className: (Categories_module_default()).slider,
  infinite: false,
  slidesToShow: 8,
  slidesToScroll: 8,
  speed: 500,
  prevArrow: /*#__PURE__*/(0,jsx_runtime.jsx)(PrevArrow/* default */.Z, {
    category: true,
    onClick: function onClick() {
      return (0,analytics/* addToAnalyticsGenericEvent */.RY)('categoryLeftClick');
    }
  }),
  nextArrow: /*#__PURE__*/(0,jsx_runtime.jsx)(NextArrow/* default */.Z, {
    category: true,
    onClick: function onClick() {
      return (0,analytics/* addToAnalyticsGenericEvent */.RY)('categoryRightClick');
    }
  }),
  responsive: [{
    breakpoint: 1200,
    settings: {
      slidesToShow: 7,
      slidesToScroll: 7
    }
  }, {
    breakpoint: 1120,
    settings: {
      slidesToShow: 6,
      slidesToScroll: 6
    }
  }, {
    breakpoint: 1024,
    settings: {
      slidesToShow: 5,
      slidesToScroll: 5
    }
  }, {
    breakpoint: 768,
    settings: {
      arrows: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      swipeToSlide: true
    }
  }, {
    breakpoint: 620,
    settings: {
      arrows: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      swipeToSlide: true
    }
  }, {
    breakpoint: 480,
    settings: {
      arrows: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      swipeToSlide: true
    }
  }, {
    breakpoint: 358,
    settings: {
      arrows: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      swipeToSlide: true
    }
  }]
};
function Categories(_ref) {
  var _ref$categories = _ref.categories,
      categories = _ref$categories === void 0 ? [] : _ref$categories;

  var _useState = (0,react.useState)(false),
      showCategories = _useState[0],
      setShowCategories = _useState[1];

  function onClickLink(category, index) {
    products/* RenderedProducts.update */.vX.update({});
    (0,analytics/* selectPromotion */.G5)({
      creative_slot: 'Categories in Home',
      creative_name: 'Categories in Home',
      items: [{
        index: index,
        item_category: category
      }]
    });
  }

  (0,react.useEffect)(function () {
    setTimeout(function () {
      (0,analytics/* viewPromotion */.vk)({
        creative_slot: 'Categories in Home',
        creative_name: 'Categories in Home'
      });
    }, 1000);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: (Categories_module_default()).container,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: (Categories_module_default()).sliderContainer,
      children: !categories.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
        height: 160
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(es/* default */.Z, _objectSpread(_objectSpread({}, SLIDER_SETTINGS), {}, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: routes/* OFFERS */.jn,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: (Categories_module_default()).tile,
            "data-cy": "offers",
            onClick: function onClick() {
              onClickLink('Προσφορές');
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Categories_module_default()).imgContainer,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (Categories_module_default()).offers
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: (Categories_module_default()).title,
              children: "\u03A0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (Categories_module_default()).count,
              children: "\u0391\u03BD\u03B1\u03BA\u03B1\u03BB\u03CD\u03C8\u03C4\u03B5 \u03C4\u03B5\u03C2"
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: routes/* SMART */.GQ,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: (Categories_module_default()).tile,
            "data-cy": "smart",
            onClick: function onClick() {
              onClickLink('smart');
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Categories_module_default()).imgContainer,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (Categories_module_default()).smart
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: (Categories_module_default()).title,
              children: "\u0388\u03BE\u03C5\u03C0\u03BD\u03B5\u03C2 \u03B1\u03B3\u03BF\u03C1\u03AD\u03C2"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (Categories_module_default()).count,
              children: "\u0391\u03BD\u03B1\u03BA\u03B1\u03BB\u03CD\u03C8\u03C4\u03B5 \u03C4\u03B5\u03C2"
            })]
          })
        }), categories.map(function (_ref2, index) {
          var divisionCode = _ref2.divisionCode,
              name = _ref2.name,
              numberOfProductsToDisplay = _ref2.numberOfProductsToDisplay,
              slugAscii = _ref2.slugAscii;
          return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "".concat(routes/* CATEGORIES */.aA, "/").concat(slugAscii),
            as: "".concat(routes/* CATEGORIES */.aA, "/").concat(slugAscii),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              className: (Categories_module_default()).tile,
              onClick: function onClick() {
                return onClickLink(name);
              },
              "data-cy": slugAscii,
              "aria-hidden": index > 6,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (Categories_module_default()).imgContainer,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (Categories_module_default())[slugAscii]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: (Categories_module_default()).title,
                children: name
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: (Categories_module_default()).count,
                children: numberOfProductsToDisplay ? "".concat(numberOfProductsToDisplay, " \u03A0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1") : ''
              })]
            })
          }, divisionCode);
        })]
      }))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Categories_module_default()).viewAllContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
        type: "button",
        className: (Categories_module_default()).categoriesBtn,
        onClick: function onClick() {
          return setShowCategories(true);
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "\u0394\u03B5\u03C2 \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03BA\u03B1\u03C4\u03B7\u03B3\u03BF\u03C1\u03AF\u03B5\u03C2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* MdKeyboardArrowRight */.AeI, {
          className: (Categories_module_default()).arrowIcon,
          alt: "\u0394\u03B5\u03C2 \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03BA\u03B1\u03C4\u03B7\u03B3\u03BF\u03C1\u03AF\u03B5\u03C2"
        })]
      })
    }), showCategories && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
      fallback: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {}),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CategoriesModal, {
        isOpen: showCategories,
        setIsOpen: setShowCategories,
        slug: ""
      })
    })]
  });
}
// EXTERNAL MODULE: ./src/components/Navigation/Navigation.jsx
var Navigation = __webpack_require__(86894);
// EXTERNAL MODULE: ./src/components/OfferBannerSection/OfferBannerSection.jsx
var OfferBannerSection = __webpack_require__(95476);
// EXTERNAL MODULE: ./src/store/categories.js
var store_categories = __webpack_require__(9266);
;// CONCATENATED MODULE: ./src/pages/index.jsx


/* Components */
















var HomepageOffersWrapper = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(260), __webpack_require__.e(2013), __webpack_require__.e(3253), __webpack_require__.e(7730), __webpack_require__.e(7007)]).then(__webpack_require__.bind(__webpack_require__, 76468));
}, {
  suspense: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(76468)];
    }
  }
});
var OfferBannerSectionBottom = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 95476));
}, {
  suspense: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(95476)];
    }
  }
});
var __N_SSG = true;
function Index(_ref) {
  var _sections$products, _sections$products2, _sections$products2$f;

  var navigation = _ref.navigation,
      _ref$sections = _ref.sections,
      sections = _ref$sections === void 0 ? {} : _ref$sections,
      footerLinks = _ref.footerLinks,
      footerUSP = _ref.footerUSP,
      promotedProducts = _ref.promotedProducts,
      offers = _ref.offers,
      meta = _ref.meta,
      preBuildProducts = _ref.preBuildProducts;

  var _useState = (0,react.useState)([]),
      categories = _useState[0],
      setCategories = _useState[1];

  var _useState2 = (0,react.useState)(false),
      showBottomContent = _useState2[0],
      setShowBottomContent = _useState2[1];

  function callback(entry) {
    if (entry[0].isIntersecting) {
      setShowBottomContent(true);
    }
  }

  (0,react.useEffect)(function () {
    var categories$ = store_categories/* default.subscribe */.Z.subscribe(setCategories);
    var hash = window.location.hash.substring(1);

    if (hash && hash === 'newsletter') {
      var element = document.documentElement;
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest'
      });
    }

    var options = {
      threshold: 0.25
    };
    var observer = new IntersectionObserver(callback, options);
    var target = document.querySelector('#listContainer');
    observer.observe(target);
    return function () {
      categories$.unsubscribe();
    };
  }, []);
  var offerBannerSection = (0,react.useMemo)(function () {
    var _sections$prosforesne, _sections$prosforesne2;

    return /*#__PURE__*/(0,jsx_runtime.jsx)(OfferBannerSection["default"], {
      sections: (_sections$prosforesne = sections.prosforesnea) === null || _sections$prosforesne === void 0 ? void 0 : (_sections$prosforesne2 = _sections$prosforesne.fields) === null || _sections$prosforesne2 === void 0 ? void 0 : _sections$prosforesne2.sections,
      analyticsTitle: "links under home banner"
    });
  }, []);
  var carousel = (0,react.useMemo)(function () {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselSection_CarouselSection, {
      data: sections.carousel
    });
  }, []);
  var categoriesMemo = (0,react.useMemo)(function () {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Categories, {
      categories: categories
    });
  }, [categories]);
  var footerUsp = (0,react.useMemo)(function () {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(FooterUSP, {
      footerUSP: footerUSP
    });
  }, []);
  var deliveryBannerMemo = (0,react.useMemo)(function () {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DeliveryBanner/* default */.Z, {});
  }, []);
  var headerNavigation = (0,react.useMemo)(function () {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (index_module_default()).headerContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {
        navigation: navigation,
        isEnabled: true
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Navigation/* default */.Z, {
        navigation: navigation
      })]
    });
  }, []);
  var footerMemo = (0,react.useMemo)(function () {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {
      footerLinks: footerLinks,
      footerUSP: footerUSP
    });
  }, []);
  var CustomMetaHeadMemo = (0,react.useMemo)(function () {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(CustomMetaHead/* default */.Z, {
      title: "\u039A\u03B1\u03C4\u03AC\u03C3\u03C4\u03B7\u03BC\u03B1 Online",
      meta: meta,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "google-site-verification",
        content: meta.googleVerification
      })
    });
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [CustomMetaHeadMemo, headerNavigation, deliveryBannerMemo, categoriesMemo, carousel, offerBannerSection, showBottomContent && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
      fallback: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {}),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(HomepageOffersWrapper, {
        promotedProducts: promotedProducts,
        offers: offers,
        preBuildProducts: preBuildProducts
      })
    }), showBottomContent && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
      fallback: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {}),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(OfferBannerSectionBottom, {
        title: (_sections$products = sections.products) === null || _sections$products === void 0 ? void 0 : _sections$products.title,
        sections: (_sections$products2 = sections.products) === null || _sections$products2 === void 0 ? void 0 : (_sections$products2$f = _sections$products2.fields) === null || _sections$products2$f === void 0 ? void 0 : _sections$products2$f.sections
      })
    }), sections.howto && /*#__PURE__*/(0,jsx_runtime.jsx)(Homepage_SingleImageBanner, {
      data: sections.howto
    }), footerUsp, footerMemo]
  });
}

/***/ }),

/***/ 90952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ earlyInUseEffect; }
/* harmony export */ });
/**
 * Use to early return in useEffect.
 * Usage example `return earlyInUseEffect;`
 */
function earlyInUseEffect() {
  return {};
}

/***/ }),

/***/ 45728:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(31662);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29172:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"img":"CarouselSectionSlideImage_img__h_YTx"};

/***/ }),

/***/ 86629:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"FooterUSP_section__GfWXv","container":"FooterUSP_container__XVKWU"};

/***/ }),

/***/ 96127:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"FooterUSPItem_container__mVYe7","text":"FooterUSPItem_text__wmNqL","description":"FooterUSPItem_description__nEfXI","header":"FooterUSPItem_header__HNAHp","img":"FooterUSPItem_img__DrBZD"};

/***/ }),

/***/ 12405:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"img":"FormattedImage_img__ai6L8"};

/***/ }),

/***/ 59517:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"img":"CarouselSection_img__HzNsS","color":"CarouselSection_color__D34E8"};

/***/ }),

/***/ 64890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"CarouselSectionSlide_container__gqAZr"};

/***/ }),

/***/ 54599:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"SingleImageBanner_container__DFnMe","img":"SingleImageBanner_img__pobSb"};

/***/ }),

/***/ 46318:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Categories_container__8_fZ_","tile":"Categories_tile__W80Z0","imgContainer":"Categories_imgContainer__fKx0l","offers":"Categories_offers__m_apC","smart":"Categories_smart__k8cZi","manabikh":"Categories_manabikh__GxK1B","fresko-kreas":"Categories_fresko-kreas__ag5_8","allantika":"Categories_allantika___t9Ak","turokomika":"Categories_turokomika__iOx_W","galaktokomika":"Categories_galaktokomika__CPpm_","eidh-psugeiou":"Categories_eidh-psugeiou__qEo6T","katapsuxh":"Categories_katapsuxh__uWFGE","pantopwleio":"Categories_pantopwleio__mvyGe","kaba":"Categories_kaba__hWFGd","proswpikh-frontida":"Categories_proswpikh-frontida__socIN","brefika":"Categories_brefika__GV6qP","kathariothta":"Categories_kathariothta__U8IBb","oikiakh-xrhsh":"Categories_oikiakh-xrhsh__QYWt9","pet-shop":"Categories_pet-shop___1yn1","biologikaleitourgika":"Categories_biologikaleitourgika__2fczE","hlektrikes-suskeues":"Categories_hlektrikes-suskeues__NcSeu","title":"Categories_title__10_Bv","count":"Categories_count__x81X_","viewAllContainer":"Categories_viewAllContainer__rC2xN","sliderContainer":"Categories_sliderContainer__vgdGU","categoriesBtn":"Categories_categoriesBtn__iCTKr","arrowIcon":"Categories_arrowIcon__3X7qn"};

/***/ }),

/***/ 98297:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"OfferBannerSection_listContainer__Yh3Jj","bannerContainer":"OfferBannerSection_bannerContainer__xDPI4","bannerTitle":"OfferBannerSection_bannerTitle__GV0vx","img":"OfferBannerSection_img__vcocb","videoContainer":"OfferBannerSection_videoContainer__gDxUf","imageContainer":"OfferBannerSection_imageContainer__qiECe","section":"OfferBannerSection_section__dAbzs","sectionTitle":"OfferBannerSection_sectionTitle__BRynt"};

/***/ }),

/***/ 80075:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"NextArrow_container__QNOMg","leaflet":"NextArrow_leaflet__pv9Bi","categoryContainer":"NextArrow_categoryContainer__32KPf","smallArrow":"NextArrow_smallArrow__eYUrr","carouselContainer":"NextArrow_carouselContainer__PSlWF","icon":"NextArrow_icon__cN9Ar"};

/***/ }),

/***/ 19392:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"PrevArrow_container__ebi1s","leaflet":"PrevArrow_leaflet__sW3Rf","smallArrow":"PrevArrow_smallArrow__BjbkX","categoryContainer":"PrevArrow_categoryContainer__iWgpN","carouselContainer":"PrevArrow_carouselContainer__4XFzB","icon":"PrevArrow_icon__Wjv_m"};

/***/ }),

/***/ 28833:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"index_headerContainer__J9svF"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5937,9866,1228,4617,5445,3609,3996,4843,9174,1515,5610,9950,9878,6126,9774,2888,179], function() { return __webpack_exec__(16395), __webpack_exec__(45728); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);